import { ENUM__redux_action } from '@/state/_base/ENUM__redux_action';
import { PayloadAction } from '@reduxjs/toolkit';
import { STATE__workspace } from '../STATE__workspace';

export const LOCAL__workspace_set_is_all_data_loaded = (payload: boolean): PayloadAction<boolean> => ({
  type: ENUM__redux_action.WORKSPACE_SET_IS_ALL_DATA_LOADED,
  payload,
});

export function INIT_LOCAL__workspace_set_is_all_data_loaded(state: STATE__workspace, action: PayloadAction<boolean>) {
  state.is_all_data_loaded = action.payload;
}
